"use strict";
/**
 * Promo List Factory
 * formats the raw data into a usable format
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const LANG_1 = __importDefault(require("../../../constants/lang/LANG"));
/**
 * Returns formated Promo list info
 * @param {PromoListType} promoInfo
 * @param {string} language
 * @returns {PromoListFactoryType}
 */
function promoListFactory(promoInfo, language = LANG_1.default.EN) {
    const isAutoApplied = (0, get_1.default)(promoInfo, 'autoApplied', false);
    return {
        id: (0, get_1.default)(promoInfo, 'id', 0),
        code: (0, get_1.default)(promoInfo, `code`, ''),
        title: (0, get_1.default)(promoInfo, `name.${language}`, ''),
        description: (0, get_1.default)(promoInfo, `description.${language}`, ''),
        validTo: (0, get_1.default)(promoInfo, `validTo`, ''),
        isAutoApplied,
        isValid: (0, get_1.default)(promoInfo, 'valid', false),
        tc: (0, get_1.default)(promoInfo, 'termsAndConditions', ''),
    };
}
exports.default = promoListFactory;
